import ShowocaseLayout from '../../../../../components/layout/ShowocaseLayout';
import AsyncPage from './async';
import React from 'react';

export default [
  <ShowocaseLayout
    key="/business/showcase/3d-viewer/home"
    exact
    path="/business/showcase/3d-viewer/home"
    component={AsyncPage}
  />,
];
